import Full from '@/containers/Full'
import Dashboard from '@/views/Dashboard'
import Login from '@/components/login'
// import Home from '@/views/home'
import RouterGroup from './groups/group'
import RouterOrganizition from './organizations/organization'
import RouterUser from './users/user'
import RouterProfile from './profiles/profile'
import RouterDocument from './documents/document'
import RouterStatus from './checklist-item-status/status'
import RouterChecklist from './checklists/checklist'
// import RouterGroupDocument from './group-documents/group-document'
import RouterChecklistItem from './checklist-items/checklist-item'
import RouterTag from './hashtag/hashtag'
// import RouterGroupChecklistItem from './group-checklist-items/group-checklist-item'
import RouterGroupFAQ from './group-faqs/group-faq'
import RouterFAQ from './faqs/faq'
import RouterQRCode from './qr-codes/qr-code'
import PageNotFound from '@/components/pages/Page404'
import RouterReport from './reports/report'
import Notification from '@/views/notification'
import RouterReportHashtag from './reports/report-hashtag'
import RouterPosition from './positions/position'
import RouterSurvey from './surveys/index'
import RouterLibrary from './library/library'
import RouteCategoryChk from './category-checklist/category-checklist'
import ForgotPassword from '@/components/forgot-password'
import ResetPassword from '@/components/forgot-password/password-reset'
import Report from './checklists/report'

export default [
  // {
  //   path: '/',
  //   name: 'home',
  //   component: Home
  // },
  {
    path: '/',
    redirect: '/checklist/list',
    name: 'header.home',
    component: Full,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: 'dashboard',
        name: 'header.dashboard',
        component: Dashboard
      },
      {
        path: 'notification',
        name: 'notification.notification',
        component: Notification
      },
      RouterGroup,
      RouterOrganizition,
      RouterUser,
      RouterProfile,
      RouterDocument,
      RouterStatus,
      RouterChecklist,
      // RouterGroupDocument,
      RouterChecklistItem,
      // RouterGroupChecklistItem,
      RouterQRCode,
      RouterGroupFAQ,
      RouterFAQ,
      RouterReport,
      RouterReportHashtag,
      RouterPosition,
      RouterSurvey,
      RouterLibrary,
      RouterTag,
      RouteCategoryChk,
      Report
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      isVisitor: true
    }
  },
  {
    path: '/password/forgot',
    name: 'forgot-password',
    component: ForgotPassword
  },
  {
    path: '/password/reset/:token',
    name: 'reset password',
    component: ResetPassword
  },
  {
    path: '/404',
    component: PageNotFound
  }
  // {
  //   path: '*',
  //   redirect: '/404'
  // }
]



// WEBPACK FOOTER //
// ./src/router/router.js